/**
 * @file Modificateur runtime (add/mult sur stat nommee, filtre de portee) et contrat ModifierSource.
 */
import type { Decimal } from '@shared/bignum';
import type { ModeId, StatId, WeaponBehavior } from '@shared/enums';
import type { ModifierFilter } from '@config/types';

export interface Modifier {
  /** Origine (ex. "upgrade:power", "skin:witch", "star:slot1") : debug + ecran de detail des bonus. */
  source: string;
  stat: StatId;
  op: 'add' | 'mult';
  value: Decimal;
  filter?: ModifierFilter;
}

/** Contexte d'evaluation : un modificateur filtre ne s'applique que si le contexte correspond. */
export interface StatQuery {
  mode?: ModeId;
  behavior?: WeaponBehavior;
  slot?: number;
  /** Ignore les modificateurs de buffs temporaires (source 'buff:*') : calcul hors-ligne. */
  excludeBuffs?: boolean;
}

export interface ModifierSink {
  push(mod: Modifier): void;
}

/** Une source de bonus (upgrades, skins, reliques, familiers, etoiles, buffs, rebirth...) declare ses modificateurs. */
export interface ModifierSource {
  readonly id: string;
  collect(sink: ModifierSink): void;
}

export const matchesFilter = (filter: ModifierFilter | undefined, q: StatQuery): boolean => {
  if (!filter) return true;
  if (filter.modes && (q.mode === undefined || !filter.modes.includes(q.mode))) return false;
  if (filter.behaviors && (q.behavior === undefined || !filter.behaviors.includes(q.behavior))) return false;
  if (filter.slots && (q.slot === undefined || !filter.slots.includes(q.slot))) return false;
  return true;
};
